export const INTEREST_TAGS = [
    // Tech & Career
    'Tech', 'Coding', 'Startups', 'Career', 'Remote Work', 'Finance', 'Crypto',

    // Arts & Culture
    'Music', 'Afrobeats', 'Amapiano', 'Art', 'Fashion', 'Photography', 'Literature',
    'History', 'Language', 'Food', 'Cooking', 'Travel',

    // Lifestyle & Identity
    'Students', 'Diaspora', 'Relationships', 'Parenting', 'Health', 'Fitness',
    'Mental Health', 'Spirituality', 'Religion',

    // Social
    'Gaming', 'Sports', 'Football', 'Basketball', 'Movies', 'Anime', 'Memes',
    'Politics', 'News'
];

export const TOPIC_TAGS = [
    "Pan-Africanism", "Pre-Colonial", "Colonial Era",
    "Independence Era", "Modern Day", "Future",
    "Philosophy", "Spirituality", "Innovation", "Tradition",
    "Music", "Art", "Literature", "Politics", "Economy"
];

// For backward compatibility if needed, though we should migrate users
export const TAGS = INTEREST_TAGS;

export const getRelatedTags = (tag: string): string[] => {
    // Simple mock recommender for MVP
    return TAGS.filter(t => t !== tag).slice(0, 3);
};
